import { render, staticRenderFns } from "./DailyTokenTVScreen.vue?vue&type=template&id=48b92124&scoped=true&"
import script from "./DailyTokenTVScreen.vue?vue&type=script&lang=js&"
export * from "./DailyTokenTVScreen.vue?vue&type=script&lang=js&"
import style0 from "./DailyTokenTVScreen.vue?vue&type=style&index=0&id=48b92124&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b92124",
  null
  
)

export default component.exports